import React from 'react'
import PropTypes from 'prop-types'
import { PatternFormat } from 'react-number-format'
import { useFormContext, Controller } from 'react-hook-form'

import { InputWrapperDiv } from '../styles/Containers'
import { TextField } from '../styles/TextField'
import Label from './Label'

const getError = (id, errors) => {
  return id.split('.').reduce((o, i) => {
    const exists = o[i] !== undefined
    if (!exists) return {}
    return o[i]
  }, errors)
}

function MaskedInput({ required = false, id, label, basis, format, disabled = false, tooltip = '', textFieldFormat = 'default' }) {
  const { register, formState, control } = useFormContext()

  const errors = formState.errors
  const error = getError(id, errors)

  return (
    <InputWrapperDiv basis={basis}>
      <Controller
        id={id}
        name={id}
        control={control}
        render={({ field: { onChange, value } }) => (
          <PatternFormat
            refs={{ ...register(id) }}
            onChange={onChange}
            value={value}
            format={format}
            mask="_"
            customInput={TextField}
            variant="standard"
            label={<Label label={label} tooltip={tooltip} />}
            InputLabelProps={{
              shrink: true,
              required,
              focused: false
            }}
            InputProps={{
              disableUnderline: true
            }}
            disabled={disabled}
            error={Object.keys(error).length > 0 && !!error}
            helperText={error?.message}
            FormHelperTextProps={{ role: 'alert' }}
            styleformat={textFieldFormat}
          />
        )}
      />
    </InputWrapperDiv>
  )
}

MaskedInput.propTypes = {
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string.isRequired,
  basis: PropTypes.string,
  format: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  textFieldFormat: PropTypes.oneOf(['default', 'condensed'])
}

export default MaskedInput
